import React from 'react';
import { StudentNavbar } from '../components';

const WhatsNew = () => {
  const released = [
  {
    title: 'Biology Beta Live',
    description:
      'Start practicing BGCSE Biology with questions, explanations, and progress that helps you improve.',
    tag: 'Live',
  },
  {
    title: 'Explore vs Guided Practice',
    description:
      'Choose how you study: select a guided path or jump into a module when you need it.',
    tag: 'Live',
  },
  {
    title: 'Smart Quizzes',
    description:
      'Target your weak spots with Smart Quizzes and focus on incorrect, in-progress, or not-started questions.',
    tag: 'Live',
  },
];

const upcoming = [
  {
    title: 'Weekly Added Questions',
    description:
      'New Biology questions added every week (Sunday) to expand coverage and improve depth.',
    eta: 'Weekly',
  },
  {
    title: 'BJC + BGCSE Math Rollout',
    description:
      'We’re bringing more subjects next—built with the same smart practice and progress tracking.',
    eta: 'Coming',
  },
  {
    title: 'AI Feedback',
    description:
      'Get instant feedback on written answers to help you improve faster.',
    eta: 'Coming',
  },
];


  return (
    <div className="min-h-screen">
      <StudentNavbar />

      <div className="px-[5%] py-10 text-white">
        {/* Hero */}
        <div className="mx-auto max-w-5xl text-center mt-6">
          <p className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-sm font-medium text-white/90">
            <span className="h-2 w-2 rounded-full bg-green-400" />
            What’s New
          </p>

          <h1 className="mt-6 text-4xl md:text-5xl font-semibold tracking-tight">
            Study Better. Study Smarter.
          </h1>

          <p className="mt-4 italic text-lg md:text-lg text-white/80 font-light">
            with progress that matters
          </p>
        </div>

        {/* Sections */}
        <div className="mx-auto max-w-5xl mt-12 grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Newly Released */}
          <div className="rounded-2xl bg-white/5 border border-white/10 p-6 shadow-lg">
            <div className="flex items-center justify-between">
              <h2 className="text-xl font-semibold">Newly Released Features</h2>
              <span className="text-xs rounded-full bg-green-400/20 text-green-300 px-3 py-1 border border-green-400/20">
                Live
              </span>
            </div>

            <div className="mt-6 space-y-4">
              {released.map((item, idx) => (
                <div
                  key={idx}
                  className="rounded-xl bg-black/20 border border-white/10 p-4 hover:bg-black/30 transition"
                >
                  <div className="flex items-start justify-between gap-3">
                    <div>
                      <h3 className="text-base font-semibold">{item.title}</h3>
                      <p className="mt-2 text-sm text-white/75 leading-relaxed">
                        {item.description}
                      </p>
                    </div>

                    <span className="shrink-0 text-xs rounded-full bg-white/10 text-white/80 px-3 py-1 border border-white/10">
                      {item.tag}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Upcoming */}
          <div className="rounded-2xl bg-white/5 border border-white/10 p-6 shadow-lg">
            <div className="flex items-center justify-between">
              <h2 className="text-xl font-semibold">Upcoming Features</h2>
              <span className="text-xs rounded-full bg-sky-400/20 text-sky-300 px-3 py-1 border border-sky-400/20">
                In Progress
              </span>
            </div>

            <div className="mt-6 space-y-4">
              {upcoming.map((item, idx) => (
                <div
                  key={idx}
                  className="rounded-xl bg-black/20 border border-white/10 p-4 hover:bg-black/30 transition"
                >
                  <div className="flex items-start justify-between gap-3">
                    <div>
                      <h3 className="text-base font-semibold">{item.title}</h3>
                      <p className="mt-2 text-sm text-white/75 leading-relaxed">
                        {item.description}
                      </p>
                    </div>

                    <span className="shrink-0 text-xs rounded-full bg-white/10 text-white/80 px-3 py-1 border border-white/10">
                      {item.eta}
                    </span>
                  </div>
                </div>
              ))}
            </div>

            {/* Optional CTA */}
            <div className="mt-6 rounded-xl bg-sky-900/20 border border-sky-400/20 p-4">
              <p className="text-sm text-white/80">
                Want a feature sooner? Message us and tell us what would help you study smarter at info.edubahamas@gmail.com
              </p>
            </div>
          </div>
        </div>

        {/* Footer note */}
        <div className="mx-auto max-w-5xl mt-10 text-center text-xs text-white/50">
          We ship updates regularly. The fastest way to improve EduBahamas is with student feedback.
        </div>
      </div>
    </div>
  );
};

export default WhatsNew;